























































































































import { Vue, Component } from 'vue-property-decorator';
import clounbtn from '../components/CloundbtnInfoLoad.vue';
import { isWeiXin } from '@/common/ts/common';
import { Toast } from 'vant';
import { intoLevelCheck } from '../api';
import qs from 'qs';

Vue.use(Toast);

@Component({
  components: {
    clounbtn,
  },
})
export default class Rule extends Vue {
  isInto: boolean = true;
  unionid: string | null = '';
  rulecontent: any = '';
  name: string = '';
  options: any = ['抖音', '微博', '小红书', 'b站'];
  platform: string = '';
  platformId: string = '';
  schname: string = '';
  phone: string = '';
  topimg: any = require('../assets/upload/morestart.png');
  secondimg: any = require('../assets/upload/midstart.png');
  threeimg: any = require('../assets/upload/threestart.png');
  nowtime: number = new Date().getTime();
  // timelist: any = {
  //   //活动时间
  //   ysstr: 1688598000000, //2023-07-06 07:00:00
  //   // ysend: 1689004800000, //2023-07-11 00:00:00
  //   ysend: 1689177600000, //2023-07-13 00:00:00
  //   csstr: 1689350400000, //2023-07-15 00:00:00
  //   // csstr: 1690473600000, //2023-07-28 00:00:00
  //   csend: 1691164800000, //2023-08-05 00:00:00
  //   jsstr: 1692460800000, //2023-08-20 00:00:00
  //   jsend: 1692979200000, //2023-08-26 00:00:00
  // };
  timelist: any = {
    //活动时间
    ysstr: 1688598000000, //2023-07-06 07:00:00
    ysend: 1689177600000, //2023-07-13 00:00:00
    csstr: 1690214400000, //2023-07-25 00:00:00
    csend: 1691078400000, //2023-08-04 00:00:00
    jsstr: 1691510400000, //2023-08-09 00:00:00
    jsend: 1692633600000, //2023-08-22 00:00:00
  };

  mounted() {
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    this.unionid = window.localStorage.getItem('unionid');
    this.isInto = true;
    setTimeout(() => {
      this.isInto = false;
    }, 200);
  }
  goback() {
    this.$router.push('index');
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  nitoUpload(type: number) {
    intoLevelCheck(type + '', this.unionid + '').then((res: any) => {
      if (res.code === 200) {
        this.$router.push('inupload?type=' + type);
      } else {
        Toast(res.msg);
      }
    });
  }
}
